import React from 'react'

import { Redirect } from 'react-router-dom'

import { useIsAuthed } from 'components/AuthShield'

import { getRememberedPath, getRememberedUrl, removeRememberedUrl } from './remembered-url'
import { urlIsInThisApp } from './scoir-url-helpers'

const getRedirectPath = () => {
  const rememberedRoute = getRememberedUrl()
  if (!rememberedRoute) {
    return null
  }
  // does this remembered url match a url in this app?
  const rememberedPath = getRememberedPath(rememberedRoute)
  if (urlIsInThisApp(rememberedPath)) {
    removeRememberedUrl()
    return rememberedPath
  }
}

const RememberedRedirect = () => {
  const isAuthed = useIsAuthed()
  if (!isAuthed) {
    return null
  }
  const path = getRedirectPath()
  if (path) {
    return <Redirect to={path} />
  }
  return null
}

export default RememberedRedirect
